export const ComponentConfig = {
    CardBorderRadius: "6px",
    ButtonBorderRadius: "12px",
    ButtonPadding: "12px",
    defaultIconSize: "16px",
    cardInnerPadding: "20px",
    fonts: {
        smallRegular: {
            fontSize: "12px",
            fontWeight: 400,
        },
        smallMedium: {
            fontSize: "12px",
            fontWeight: 500,
        },
        smallBold: {
            fontSize: "12px",
            fontWeight: 600,
        },
        bodyRegular: {
            fontSize: "14px",
            fontWeight: 400,
        },
        bodyMedium: {
            fontSize: "14px",
            fontWeight: 500,
        },
        bodyBold: {
            fontSize: "14px",
            fontWeight: 600,
        },
        subtitleRegular: {
            fontSize: "16px",
            fontWeight: 400,
        },
        subtitleMedium: {
            fontSize: "16px",
            fontWeight: 500,
        },
        subtitleBold: {
            fontSize: "16px",
            fontWeight: 600,
        },
        titleRegular: {
            fontSize: "18px",
            fontWeight: 400,
        },
        titleMedium: {
            fontSize: "18px",
            fontWeight: 500,
        },
        titleBold: {
            fontSize: "18px",
            fontWeight: 600,
        },
    },
    primaryButtonGradient: "linear-gradient(180deg, #179D82 0%, #0B7963 100%);",
}